import { useEffect, useState } from 'react';

import type { SpeechSynthesisPort } from '@/shared-responder-v2-core';

import {
  createSpeechSynthesisPort,
  type SpeechSynthesisPortInput,
} from './shared-responder-v2-media-speech.helpers';

export function useSpeechSynthesisPortFromMutation(
  requestAudioData: SpeechSynthesisPortInput['requestAudioData']
): SpeechSynthesisPort {
  const [port] = useState(() =>
    createSpeechSynthesisPort({ language: null, requestAudioData })
  );

  useEffect(() => () => port.dispose(), [port]);

  return port;
}
